export const isArrayWithData = (param: any) => {
    return !!param && Array.isArray(param) && param.length > 0;
};

export const getBatch = (arr: any[], page: number, size = 10) => {
    const start = page * size;
    return arr?.slice(start, start + size) || [];
};
